import { Injectable } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import * as moment from "moment";

@Injectable()
export class ExamineeForm {
  constructor(private fb: FormBuilder) {}

  build(): FormGroup {
    return this.fb.group(
      {
        StudentId: ["", { updateOn: "blur" }],
        ACTId: [""],
        ACCOMMS_PIN: [""],
        ExtPersonId: [""],
        FirstName: ["", [Validators.required]],
        MiddleName: [""],
        LastName: ["", [Validators.required]],
        DOB: ["", [Validators.required]],
        Country: ["", [Validators.required]],
        Address1: ["", [Validators.required]],
        Address2: [""],
        InternationalZip: [""],
        InternationalCity: [""],
        NationalZip: [""],
        NationalState: [""],
        NationalCity: [""]
      },
      {
        validator: formControl => {
          const sid = formControl.controls
            ? formControl.controls.StudentId
            : undefined;
          const aid = formControl.controls
            ? formControl.controls.ACTId
            : undefined;
          const dob = formControl.controls
            ? formControl.controls.DOB
            : undefined;
          if (sid !== undefined || aid !== undefined) {
            if (
              !(
                (sid.value && sid.value.length) ||
                (aid.value && aid.value.length)
              )
            ) {
              return { actOrSidRequired: true };
            }
          }

          if (aid.value) {
            const submitActID = aid.value.replace(/-/gi, "");
            if (!(submitActID.length === 8 || submitActID.length === 9)) {
              return { invalidActIdPattern: true };
            }
          }

          if (dob !== undefined && dob.value) {
            if (typeof dob.value === "string") {
              dob.value = new Date(dob.value);
            }

            const age = moment().diff(moment(dob.value), 'years');
            console.log("age", age);
            if (age >= 60 || age < 0) {
              return { minDob: true };
            }

            dob.value = moment(dob.value).format("MM/DD/YYYY");
          }
          return null;
        }
      }
    );
  }
}



// WEBPACK FOOTER //
// ./client/views/request/examinee/examinee.form.ts